import type { AuditEntry } from '../api';
import { useAudit } from '../data';
import { fmtDate, fmtDateTime, FIELD_LABEL } from '../format';
import { ErrorBox, Loading, Modal } from './kit';

const show = (v: unknown): string => {
  if (v === null || v === undefined || v === '') return 'vazio';
  if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return fmtDate(v);
  if (typeof v === 'boolean') return v ? 'sim' : 'não';
  if (Array.isArray(v)) return v.length ? `${v.length} item(ns)` : 'nenhum';
  if (typeof v === 'object') return JSON.stringify(v);
  return String(v);
};

export function AuditTimeline({ rows }: { rows: AuditEntry[] }) {
  if (!rows.length) return <p className="muted">Nenhum registro no histórico.</p>;
  return (
    <div className="timeline">
      {rows.map(r => (
        <div className="ev" key={r.id}>
          <div className="when">{fmtDateTime(r.at)} · {r.userName ?? 'sistema'}</div>
          <div><strong>{r.operation}</strong>{r.recordLabel ? <span className="muted"> · {r.recordLabel}</span> : null}</div>
          {r.reason && <div className="small">Justificativa: {r.reason}</div>}
          {r.changes?.length > 0 && (
            <div className="diff">
              {r.changes.slice(0, 12).map((c, i) => <div key={i}>{FIELD_LABEL[c.campo] ?? c.campo}: <s>{show(c.de)}</s> → <ins>{show(c.para)}</ins></div>)}
              {r.changes.length > 12 && <div>e mais {r.changes.length - 12} campo(s)</div>}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

/** Histórico de um registro (quem alterou, quando, valor anterior e novo). */
export function HistoryModal({ projectId, recordId, title, onClose }: { projectId: string; recordId: string; title: string; onClose: () => void }) {
  const q = useAudit(projectId, recordId);
  return (
    <Modal title={`Histórico · ${title}`} onClose={onClose}>
      {q.isLoading ? <Loading /> : q.error ? <ErrorBox error={q.error} /> : <AuditTimeline rows={q.data ?? []} />}
    </Modal>
  );
}
